import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Tabs,
} from "antd";
import React, { useState } from "react";
import { Content } from "antd/es/layout/layout";
import "./style.css";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { IoMdAdd } from "react-icons/io";

const Index = ({ setActive }) => {
  const [form] = Form.useForm();
  const [secBuyer, setSecBuyer] = useState(false);
  const [thirdBuyer, setThirdBuyer] = useState(false);
  const [showServicesFeeOptions, setShowServicesFeeOptions] = useState(false);
  const [showCommissionOptions, setShowCommissionOptions] = useState(true);
  const [percentageOptions, setPercentageOptions] = useState(false);
  const [flatfeeOptions, setFlatfeeOptions] = useState(false);
  const [hourlyFees, setHoulyFees] = useState(false);
  const [commissionFee, setCommissionFee] = useState("percentage");

  const onFinish = async (values) => {
    setActive(true);
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/buyer-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Buyer Form"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false);
  };

  const handleCheckboxChange = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === "Commission") {
      setShowCommissionOptions(true);
      setShowServicesFeeOptions(false);
      setHoulyFees(false);
    } else if (selectedValue === "Services_Fee") {
      setShowServicesFeeOptions(true);
      setShowCommissionOptions(false);
      setHoulyFees(false);
    } else if (selectedValue === "Hourly_Fee") {
      setHoulyFees(true);
      setShowCommissionOptions(false);
      setShowServicesFeeOptions(false);
    } else {
      setHoulyFees(false);
      setShowCommissionOptions(false);
      setShowServicesFeeOptions(false);
    }
  };

  return (
    <Content style={{ height: "100vh", padding: "12px" }}>
      <div className="main">
        <Form
          className="signup-form"
          onFinish={onFinish}
          form={form}
          layout="vertical"
          name="offerForm"
        >
          <div className="fieldMain">
            <div className={`field ${secBuyer ? "" : "mtMinus"}`}>
              <div>
                <div className="plusHeader">
                  {(!secBuyer || !thirdBuyer) && (
                    <div
                      className="plus"
                      onClick={() => {
                        if (!secBuyer) {
                          setSecBuyer(true);
                        } else {
                          setThirdBuyer(true);
                        }
                      }}
                    >
                      +
                    </div>
                  )}

                  <label className="form-title" for="buyerName">
                    Buyer(s) Full Name
                  </label>
                </div>
                <Form.Item
                  name="buyerName"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secBuyer && (
                <Form.Item
                  name="buyerName2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
              {thirdBuyer && (
                <Form.Item
                  name="buyerName3"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
            <div className="field">
              <div>
                <label className="form-title" for="buyerAddress">
                  Buyer(s) Address
                </label>
                <Form.Item
                  name="buyerAddress"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secBuyer && (
                <Form.Item
                  name="buyerAddress2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
              {thirdBuyer && (
                <Form.Item
                  name="buyerAddress3"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
          </div>
          <hr />

          <div className="fieldMain">
            <div className="field">
              <label className="form-title" for="agentFullName">
                Agent Full Name
              </label>
              <Form.Item
                name="agentFullName"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="agentLicenseNumber">
                Agent License Number
              </label>
              <Form.Item
                name="agentLicenseNumber"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter License Number"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="agentBrokerage">
                Agent Brokerage
              </label>
              <Form.Item
                name="agentBrokerage"
                rules={[{ required: true, message: "required!" }]}
                initialValue={"Vicente Realty, LLC"}
              >
                <Input
                  className="input"
                  // placeholder="Enter address"
                  autoComplete="off"
                  disabled={true}
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="brokerageLicenseNumber">
                Brokerage License Number
              </label>
              <Form.Item
                name="brokerageLicenseNumber"
                rules={[{ required: true, message: "required!" }]}
                initialValue="9799"
              >
                <Input
                  className="input"
                  // placeholder="Enter address"
                  autoComplete="off"
                  disabled
                />
              </Form.Item>
            </div>
          </div>

          <div className="radioMain">
            <Form.Item
              // label="radio"
              name="radio1"
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  columnGap: "1rem",
                }}
              >
                <Radio value="Salesperson">Salesperson</Radio>
                <Radio value="Broker">Broker</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              // label="radio"
              name="radio2"
              rules={[{ required: true, message: "required!" }]}
              initialValue="Designated Agency"
            >
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  columnGap: "1rem",
                }}
              >
                <Radio value="Non-Designated Agency">
                  Non-Designated Agency
                </Radio>
                <Radio value="Designated Agency">Designated Agency</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              // label="radio"
              name="radio3"
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group>
                <Radio value="Buyer's agent">Buyer's Agent</Radio>
                <Radio value="Facilitator">Facilitator</Radio>
                <Radio value="Dual agent">Dual Agent</Radio>
              </Radio.Group>
            </Form.Item>
          </div>

          <hr />

          <div
            style={{
              display: "flex",
              columnGap: "2rem",
              alignItems: "flex-start",
            }}
          >
            <label>Term of Agency:</label>
            <div className="fieldMain">
              <div className="field">
                <Form.Item
                  label="Start Date"
                  name={"terms_of_agency_starting_date"}
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                  ]}
                >
                  <DatePicker format="DD-MM-YYYY" />
                </Form.Item>
              </div>
              <div className="field">
                <Form.Item
                  label="End Date"
                  name={"terms_of_agency_ending_date"}
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                  ]}
                >
                  <DatePicker format="DD-MM-YYYY" />
                </Form.Item>
              </div>
            </div>
          </div>

          <div>
            <label>Additional Provisions of Term (if any):</label>
            <Form.Item
              name={"additional_provisions_of_terms"}
              rules={[
                {
                  required: true,
                  message: "required!",
                },
              ]}
            >
              <Input.TextArea
                rows={2}
                autoSize={false}
                style={{ resize: "none", width: "100%" }}
              />
            </Form.Item>
          </div>
          <hr />
          <div>
            <div>
              <label>Broker's Services</label>
              <Form.Item
                name={"brooker_services"}
                rules={[
                  {
                    required: true,
                    message: "required",
                  },
                ]}
              >
                <Input.TextArea
                  rows={2}
                  autoSize={false}
                  style={{ resize: "none", width: "100%" }}
                />
              </Form.Item>
            </div>
          </div>
          <hr />
          <div className="fieldMain">
            <div className="field">
              <label>Broker's Compensation</label>
              <Form.Item
                name={"brookers_compensation"}
                rules={[
                  {
                    required: true,
                    message: "required",
                  },
                ]}
                initialValue="Commission"
              >
                <Radio.Group onChange={handleCheckboxChange}>
                  <Radio value={"Services_Fee"}>Services Fee</Radio>
                  {/* <Radio value={"Hourly_Fee"}>Hourly Fee</Radio> */}
                  <Radio value={"Commission"}>Commission</Radio>
                </Radio.Group>
              </Form.Item>

              <div style={{ marginLeft: "1rem" }}>
                {" "}
                {showServicesFeeOptions && (
                  <Form.Item name={"ServicesFeeOptions"}>
                    <Form.Item
                      name="service_fee"
                      rules={[
                        {
                          required: true,
                          message: "required",
                        },
                      ]}
                    >
                      <Input placeholder="$" />
                    </Form.Item>

                    <Form.Item
                      name="service_paymentTerms"
                      rules={[
                        {
                          required: true,
                          message: "required",
                        },
                      ]}
                    >
                      <Radio.Group style={{ marginTop: "1rem" }}>
                        <Radio value="due_and_payable_upon_execution_of_this_Agreement">
                          due and payable upon execution of this Agreement
                        </Radio>
                        <Radio value="due_and_payable_upon_receipt_of_invoice(s)_from_BROKER">
                          due and payable upon receipt of invoice(s) from BROKER
                        </Radio>
                      </Radio.Group>
                    </Form.Item>

                    <Form.Item
                      name="service_shall"
                      rules={[
                        {
                          required: true,
                          message: "required",
                        },
                      ]}
                    >
                      <Radio.Group style={{ marginTop: "1rem" }}>
                        <Radio value="shall">shall</Radio>
                        <Radio value="shall_not">shall not</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Form.Item>
                )}
              </div>

              <div>
                {hourlyFees && (
                  <Form.Item
                    name={"hourlyfee_options"}
                    style={{ marginLeft: "1rem" }}
                  >
                    <label>Hourly Fee per hour</label>
                    <Form.Item
                      name={"hourly_fee"}
                      rules={[
                        {
                          required: true,
                          message: "required",
                        },
                      ]}
                    >
                      <Input placeholder="$" />
                    </Form.Item>

                    <Form.Item
                      name={"hourly_fee_Shall"}
                      rules={[
                        {
                          required: true,
                          message: "required",
                        },
                      ]}
                    >
                      <Radio.Group style={{ marginTop: "1rem" }}>
                        <Radio value={"shall"}>shall</Radio>
                        <Radio value={"shall_not"}>shall not</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Form.Item>
                )}
              </div>
              {showCommissionOptions && (
                <>
                  <Form.Item
                    name="commissionOptions"
                    rules={[
                      {
                        required: true,
                        message: "required",
                      },
                    ]}
                    initialValue="percentage"
                  >
                    <Radio.Group
                      onChange={(e) => setCommissionFee(e.target.value)}
                    >
                      {/* <Radio value="flatFee">Flat Fee</Radio> */}
                      <Radio value="percentage">Percentage</Radio>
                    </Radio.Group>
                  </Form.Item>
                  {commissionFee == "percentage" ? (
                    <div style={{ marginTop: "1rem", marginLeft: "1rem" }}>
                      <Form.Item
                        name="commission_fee"
                        rules={[
                          {
                            required: true,
                            message: "required",
                          },
                        ]}
                      >
                        <Input placeholder="%" style={{ marginTop: "1rem" }} />
                      </Form.Item>
                      <Form.Item
                        name="commission_percentageType"
                        rules={[
                          {
                            required: true,
                            message: "Please select a percentage type",
                          },
                        ]}
                        initialValue="net"
                      >
                        <Radio.Group>
                          {/* <Radio value="gross">Gross</Radio> */}
                          <Radio value="net">Net</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  ) : commissionFee == "flatFee" ? (
                    <Form.Item
                      name="commission_fee"
                      rules={[
                        {
                          required: true,
                          message: "Please enter a flat fee amount",
                        },
                      ]}
                    >
                      <Input placeholder="$" />
                    </Form.Item>
                  ) : null}
                </>
              )}
            </div>
          </div>

          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      </div>
    </Content>
  );
};

export default Index;
